module.exports = __webpack_public_path__ + "static/media/TMT 2a2.f8bd7d5b.jpg";